enum CalculationType {
    Add         = 1,
    Subtract    = 2,
    Multiply    = 3,
    Divide      = 4,
}

export { CalculationType }